import React, { useEffect, useState } from 'react';

import { DeviceV3 } from '../../../../../../backendsdk';
import useDevices from '../../../../../../hooks/devices';
import { MILLISECONDS_IN_SECOND } from '../../../../../../utils/TimeFormatter';
import VehicleSelector from '../../components/VehicleSelector';

interface DeviceSelectorProps {
    onDeviceChange: (device: DeviceV3 | null) => void;
}

const DeviceSelector: React.FC<DeviceSelectorProps> = ({ onDeviceChange }) => {
    const { devices, updateDevices } = useDevices();
    const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);

    const selectedDevice =
        selectedDeviceId != null ? devices.find((d) => d.device.device_id === selectedDeviceId) ?? null : null;

    useEffect(() => {
        const intervalId = setInterval(() => {
            updateDevices();
        }, 15 * MILLISECONDS_IN_SECOND);

        return () => clearInterval(intervalId);
    }, [updateDevices]);

    const handleSelect = (device: DeviceV3 | null) => {
        setSelectedDeviceId(device?.device.device_id ?? null);
        onDeviceChange(device);
    };

    return <VehicleSelector value={selectedDevice} onSelect={handleSelect} showDeviceNotTurnedOnWarning={true} />;
};

export default DeviceSelector;
